import { render } from "./DocumentReferenceEditRow.vue?vue&type=template&id=58071a6e&ts=true"
import script from "./DocumentReferenceEditRow.ts?vue&type=script&lang=ts&external"
export * from "./DocumentReferenceEditRow.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__